import { Container, Divider } from '@mui/material';
import React from 'react';
import Header from 'components/layout/Header';

import commonStyles from 'styles/common.module.scss';
import styles from './PublicPageLayout.module.scss';

interface PublicPageLayoutProps {
  title?: React.ReactNode;
  hasFooter?: boolean;
}

const PublicPageLayout: React.FunctionComponent<PublicPageLayoutProps> = ({
  children,
  title = '',
  hasFooter = false,
}) => {
  return (
    <>
      <Header />
      <Container maxWidth={'lg'} data-testid={'public-page-layout'}>
        <div className={hasFooter ? styles.footerContainer : styles.container} data-testid={'container'}>
          {title && (
            <>
              <h1 className={commonStyles.pageTitle}>{title}</h1>
              <Divider className={styles.divider} />
            </>
          )}
          {children}
        </div>
      </Container>
    </>
  );
};
export default PublicPageLayout;
